<div class="container-fluid">
  <div class="py-4 carousel-wrapper">
    <ngx-slick-carousel #slickModal="slick-carousel" class="carousel" [config]="slideConfig">
      <div ngxSlickItem *ngFor="let item of carouselData" class="slide">
        <div class="row align-items-stretch m-0 p-0 g-0">
          
          <!-- Content Column -->
          <div class="col-12 col-md-5 content-column order-1 order-md-1">
            <h3 class="title">{{ item.title }}</h3>
            <a class="text-decoration-none aDesign" href="#">
              دعوة الشركات المتخصصة فى مجال الحديد والصلب لحضور مؤتمر الهيئة
            </a>
            <p class="subTi">{{ item.desc }}</p>
            <a href="#" class="text-danger mt-3 mb-5 text-decoration-none read-more-link">
              اضغط هنا
            </a>
          </div>

          <!-- Image Column -->
          <div class="col-12 col-md-7 p-0 order-2 order-md-2">
            <img [src]="item.image" class="carousel-image" alt="{{ item.title }}" />
          </div>
          
        </div>
      </div>
    </ngx-slick-carousel>

    <!-- Navigation Buttons -->
    <div class="navigation-buttons">
      <button class="btnGreen" (click)="moveSlider(true)">
        &#8594; التالي
      </button>
      <button class="btnGreen" (click)="moveSlider(false)">
        السابق &#8592;
      </button>
    </div>
  </div>
</div>